export const graphData = [
  ["Egon (Tiedemen)", "Claudia (Tiedemen)"],
  ["Doris (Tiedemen)", "Claudia (Tiedemen)"],
  ["Claudia (Tiedemen)", "Regina (Tiedemen)"],
  ["Regina (Tiedemen)", "Bartosz (Tiedemen)"],
  ["Aleksander (Tiedemen)", "Bartosz (Tiedemen)"],
  ["Bartosz (Tiedemen)", "Hanno 'Noah' (Tauber)"],
  ["Silja (Tiedemen)", "Hanno 'Noah' (Tauber)"],
  ["Bartosz (Tiedemen)", "Agnes (Nielsen)"],
  ["Silja (Tiedemen)", "Agnes (Nielsen)"],
  ["Agnes (Nielsen)", "Tronte (Nielsen)"],
  ["The Unknown (pack of 3)", "Tronte (Nielsen)"],
  ["Tronte (Nielsen)", "Ulrich (Nielsen)"],
  ["Jana (Nielsen)", "Ulrich (Nielsen)"],
  ["Tronte (Nielsen)", "Mads (Nielsen)"],
  ["Jana (Nielsen)", "Mads (Nielsen)"],
  ["Ulrich (Nielsen)", "Martha (Nielsen)"],
  ["Ulrich (Nielsen)", "Magnus (Nielsen)"],
  ["Ulrich (Nielsen)", "Mikkel (Nielsen)/ Michael (Kahnwald)"],
  ["Katherina (Nielsen)", "Martha (Nielsen)"],
  ["Katherina (Nielsen)", "Magnus (Nielsen)"],
  ["Katherina (Nielsen)", "Mikkel (Nielsen)/ Michael (Kahnwald)"],
  ["Daniel (Kahnwald)", "Ines (Kahnwald)"],
  ["Ines (Kahnwald)", "Mikkel (Nielsen)/ Michael (Kahnwald)"],
  ["Sebastian (Krüger)", "Hannah (Kahnwald)"],
  ["Mikkel (Nielsen)/ Michael (Kahnwald)", "Jonas (Kahnwald)"],
  ["Hannah (Kahnwald)", "Jonas (Kahnwald)"],
  ["Hannah (Kahnwald)", "Silja (Tiedemen)"],
  ["Egon (Tiedemen)", "Silja (Tiedemen)"],
  ["Jonas (Kahnwald)", "Jonas (Kahnwald)"],
  ["Martha (Nielsen)", "The Unknown (pack of 3)"],
  ["Bernd (Doppler)", "Regina (Tiedemen)"],
  ["Bernd (Doppler)", "Helge (Doppler)"],
  ["Greta (Doppler)", "Helge (Doppler)"],
  ["Helge (Doppler)", "Peter (Doppler)"],
  ["Peter (Doppler)", "Franziska (Doppler)"],
  ["Charlotte (Doppler)", "Franziska (Doppler)"],
  ["Peter (Doppler)", "Elisabeth (Doppler)"],
  ["Charlotte (Doppler)", "Elisabeth (Doppler)"],
  ["Elisabeth (Doppler)", "Charlotte (Doppler)"],
  ["Hanno 'Noah' (Tauber)", "Charlotte (Doppler)"],
  ["H.G. Tannhaus", "Charlotte (Doppler)"],
];

export const characterUrl = {
  "Egon (Tiedemen)": "https://dark-netflix.fandom.com/wiki/Egon_Tiedemann",
  "Claudia (Tiedemen)":
    "https://dark-netflix.fandom.com/wiki/Claudia_Tiedemann",
  "Doris (Tiedemen)": "https://dark-netflix.fandom.com/wiki/Doris_Tiedemann",
  "Regina (Tiedemen)": "https://dark-netflix.fandom.com/wiki/Regina_Tiedemann",
  "Bartosz (Tiedemen)":
    "https://dark-netflix.fandom.com/wiki/Bartosz_Tiedemann",
  "Aleksander (Tiedemen)":
    "https://dark-netflix.fandom.com/wiki/Aleksander_Tiedemann",
  "Hanno 'Noah' (Tauber)": "https://dark-netflix.fandom.com/wiki/Hanno_Tauber",
  "Silja (Tiedemen)": "https://dark-netflix.fandom.com/wiki/Silja_Tiedemann",
  "Agnes (Nielsen)": "https://dark-netflix.fandom.com/wiki/Agnes_Nielsen#",
  "Tronte (Nielsen)": "https://dark-netflix.fandom.com/wiki/Tronte_Nielsen",
  "The Unknown (pack of 3)": "https://dark-netflix.fandom.com/wiki/The_Unknown",
  "Ulrich (Nielsen)": "https://dark-netflix.fandom.com/wiki/Ulrich_Nielsen",
  "Jana (Nielsen)": "https://dark-netflix.fandom.com/wiki/Jana_Nielsen",
  "Mads (Nielsen)": "https://dark-netflix.fandom.com/wiki/Mads_Nielsen",
  "Martha (Nielsen)": "https://dark-netflix.fandom.com/wiki/Martha_Nielsen",
  "Magnus (Nielsen)": "https://dark-netflix.fandom.com/wiki/Magnus_Nielsen",
  "Mikkel (Nielsen)/ Michael (Kahnwald)":
    "https://dark-netflix.fandom.com/wiki/Michael_Kahnwald",
  "Katherina (Nielsen)":
    "https://dark-netflix.fandom.com/wiki/Katharina_Nielsen",
  "Daniel (Kahnwald)": "https://dark-netflix.fandom.com/wiki/Daniel_Kahnwald",
  "Ines (Kahnwald)": "https://dark-netflix.fandom.com/wiki/Ines_Kahnwald",
  "Sebastian (Krüger)":
    "https://dark-netflix.fandom.com/wiki/Sebastian_Kr%C3%BCger",
  "Hannah (Kahnwald)": "https://dark-netflix.fandom.com/wiki/Hannah_Kahnwald",
  "Jonas (Kahnwald)": "https://dark-netflix.fandom.com/wiki/Jonas_Kahnwald",
  "Bernd (Doppler)": "https://dark-netflix.fandom.com/wiki/Bernd_Doppler",
  "Helge (Doppler)": "https://dark-netflix.fandom.com/wiki/Helge_Doppler",
  "Greta (Doppler)": "https://dark-netflix.fandom.com/wiki/Greta_Doppler",
  "Peter (Doppler)": "https://dark-netflix.fandom.com/wiki/Peter_Doppler",
  "Franziska (Doppler)":
    "https://dark-netflix.fandom.com/wiki/Franziska_Doppler",
  "Charlotte (Doppler)":
    "https://dark-netflix.fandom.com/wiki/Charlotte_Doppler",
  "Elisabeth (Doppler)":
    "https://dark-netflix.fandom.com/wiki/Elisabeth_Doppler",
  "H.G. Tannhaus": "https://dark-netflix.fandom.com/wiki/H.G._Tannhaus",
};
